import(/* webpackMode: "eager" */ "/codegiant/app/global-error.tsx");
